import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PropertiesService } from "@scaffold/services/properties.service";
import { DataModelService } from "@services/data-model.service";

@Component({
  selector: "app-keys-filter-input",
  templateUrl: "./keys-filter-input.component.html",
  styleUrls: ["./keys-filter-input.component.scss"],
})
export class KeysFilterInputComponent implements OnInit {
  @Input() selectedItem;
  @Input() rootItem;
  @Input() item: any;
  @Input() parentView: any;
  @Input() fileSet: boolean;
  @Output() changed = new EventEmitter();

  public options = [];
  public selectedOperationOptions = [{label:'Exact Match' ,value:'match'},{label:'Contains',value:'contains'},{label:'Does Not Contain',value:'notContains'},{label:'Field is Available',value:'available'}]
  public selectedKeys = [];
  public selectedKey = "";
  public selectedOperation = "";
  public filterText = "";
  public queries = [];
  public queryConditional = "and";

  constructor(
    private dataModelService: DataModelService,
    public properties: PropertiesService
  ) {}

  ngOnInit(): void {
    this.queries = this?.selectedItem?.[this?.item?.param]?.queries || [];
    this.queryConditional =
      this?.selectedItem?.[this?.item?.param]?.queryConditional || "and";
    this.dataModelService
      .getKeys(this.selectedItem?.list_view)
      .subscribe((keys) => {
        if (Array.isArray(keys)) {
          this.options = [...keys];
        }
      });
  }

  addQuery() {
    this.queries.push({
      text: this.filterText,
      key: this.selectedKey,
      operation: this.selectedOperation,
    });
    this.selectedItem[this.item.param] = {
      queries: this.queries,
      queryConditional: this.queryConditional,
    };
    this.filterText = "";
    this.selectedKey = "";
    this.selectedOperation = "";
    this.properties.changeValue();
    this.changed.emit("");
  }

  removeQuery(index) {
    this.queries.splice(index, 1);
    this.selectedItem[this.item.param] = {
      queries: this.queries,
      queryConditional: this.queryConditional,
    };
    this.properties.changeValue();
    this.changed.emit("");
  }

  updateQueryConditional() {
    this.selectedItem[this.item.param] = {
      queries: this.queries,
      queryConditional: this.queryConditional,
    };
    this.properties.changeValue();
    this.changed.emit("");
  }
}
